import type { FormDefinition } from '../../format/form-definition';
import { openFormDefinition } from '../../format/open';
import { refused, type EditFunctions, type EditResult } from './editContracts';
import { elementEdits, type ElementEdit } from './elementEdits';
import { formSettingsEdits, type FormSettingsEdit } from './form-settings';
import { type ArrangingEdit, arrangingEdits } from './arranging';
import { validationsEdits, type ValidationsEdit } from './validationsEdits';

export type Edit = FormSettingsEdit | ElementEdit | ArrangingEdit | ValidationsEdit;

const editFunctions: EditFunctions<Edit> = {
  ...formSettingsEdits,
  ...elementEdits,
  ...arrangingEdits,
  ...validationsEdits,
};
export const applyEdit = (form: FormDefinition, edit: Edit): EditResult => {
  const editFunction = editFunctions[edit.kind] as (form: FormDefinition, edit: Edit) => EditResult;
  const result = editFunction(form, edit);
  if (result.kind === 'refused') return result;
  const next = result.form;
  if (next === form) return result;
  const reason = firstReason(next);
  return reason === undefined ? result : refused(reason);
};

const firstReason = (next: FormDefinition): string | undefined => {
  const opened = openFormDefinition(next);
  return opened.ok ? undefined : opened.reasons[0]?.text;
};
